/* eslint-disable @typescript-eslint/no-explicit-any */
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

export interface PdfDocument {
  url: string;
  title: string;
}

export interface PdfViewerOptions {
  showDownloadPDF?: boolean;
  showPrintPDF?: boolean;
  showLeftHandPanel?: boolean;
  showPageControls?: boolean;
  showAnnotationTools?: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class AdobePdfService {
  private defaultOptions: PdfViewerOptions = {
    showDownloadPDF: true,
    showPrintPDF: true,
    showLeftHandPanel: false,
    showPageControls: true,
    showAnnotationTools: false,
  };

  embedPdf(
    url: string,
    containerId: string,
    title: string,
    options?: PdfViewerOptions,
    embedMode: 'SIZED_CONTAINER' | 'LIGHT_BOX' = 'SIZED_CONTAINER'
  ): void {
    if (!(window as any).AdobeDC) {
      console.warn('Adobe DC SDK not loaded');
      return;
    }

    if (embedMode === 'SIZED_CONTAINER') {
      const container = document.getElementById(containerId);
      if (!container) {
        return;
      }
    }

    const viewConfig: any = {
      clientId: environment.adobePdfClientId,
    };

    if (embedMode === 'SIZED_CONTAINER') {
      viewConfig.divId = containerId;
    }

    const adobeDCView = new (window as any).AdobeDC.View(viewConfig);

    adobeDCView.previewFile(
      {
        content: { location: { url } },
        metaData: { fileName: title },
      },
      {
        embedMode,
        defaultViewMode: 'FIT_PAGE',
        ...this.defaultOptions,
        ...options,
      }
    );
  }

  embedMultiplePdfs(
    documents: PdfDocument[],
    containerPrefix = 'adobe-dc-view',
    options?: PdfViewerOptions
  ): void {
    documents.forEach((doc, index) => {
      const containerId = `${containerPrefix}-${index + 1}`;
      this.embedPdf(doc.url, containerId, doc.title, options);
    });
  }
}
